<template>
  <a-modal :visible="visible" :title="goods ? goods.name : '选择规格'" :footer="null"
           width="420px" @cancel="$emit('cancel')">
    <div class="spec-list">
      <div v-for="unit in units" :key="unit.extendId" class="spec-row" @click="pick(unit)">
        <div class="spec-info">
          <div class="spec-unit">
            {{ unit.unit }}
            <span v-if="unit.sku" class="spec-sku">{{ unit.sku }}</span>
          </div>
          <div class="spec-barcode">{{ unit.barCode }}</div>
        </div>
        <div class="spec-price">
          <span :class="{ 'price-member': isMemberPrice(unit) }">¥{{ format(unit.price) }}</span>
          <span v-if="isMemberPrice(unit)" class="price-origin">¥{{ format(unit.retailPrice) }}</span>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
  /**
   * 规格选择：多单位行商品点选 extend 行（瓶/箱各配各价）
   */
  export default {
    name: 'SpecSelectModal',
    props: {
      visible: { type: Boolean, default: false },
      goods: { type: Object, default: null }
    },
    computed: {
      units() {
        return this.goods && this.goods.units ? this.goods.units : []
      }
    },
    methods: {
      isMemberPrice(unit) {
        return unit.memberPriceHit === 1 && Number(unit.price) !== Number(unit.retailPrice)
      },
      format(price) {
        const n = Number(price)
        return isNaN(n) ? '--' : n.toFixed(2)
      },
      pick(unit) {
        this.$emit('ok', { goods: this.goods, unit })
        this.$emit('cancel')
      }
    }
  }
</script>

<style scoped>
  .spec-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .spec-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #eee;
    border-radius: 6px;
    padding: 10px 14px;
    cursor: pointer;
  }
  .spec-row:hover {
    border-color: #0081ff;
    background: #f0f8ff;
  }
  .spec-unit {
    font-size: 15px;
    color: #333;
    font-weight: 500;
  }
  .spec-sku {
    color: #999;
    font-size: 12px;
    margin-left: 6px;
  }
  .spec-barcode {
    color: #999;
    font-size: 12px;
    margin-top: 2px;
  }
  .spec-price {
    text-align: right;
  }
  .price-member {
    color: #e4393c;
    font-size: 16px;
    font-weight: 600;
  }
  .price-origin {
    color: #999;
    font-size: 12px;
    text-decoration: line-through;
    margin-left: 4px;
  }
</style>
